import React, { useState, useEffect } from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import "./Toggledarkmode.scss";

const Toggletheme = () => {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const [isActive, setIsActive] = useState(theme === "dark");

  useEffect(() => {
    document.body.classList.remove("light", "dark");
    document.body.classList.add(theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const darkandlightmode = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    setIsActive(newTheme === "dark"); 
  };

  return (
    <div className={`theme-toggle-container ${theme}`}>
      <div className={`theme-toggle-label ${isActive ? "active" : ""}`} onClick={darkandlightmode}>
        <FaSun className="sun-icon" />
        <FaMoon className="moon-icon" />
        <span className="toggle-slider"></span>
      </div>
    </div>
  );
};

export default Toggletheme;
